import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteUser as deleteUserApi } from '../services/apiUsers.ts'
import { toast } from '../utils/sweetAlert.ts'

export function useDeleteUser(id: string | number) {
  const queryClient = useQueryClient()

  const { isPending: isDeleting, mutate: deleteUser, mutateAsync: deleteUserAsync } = useMutation({
    mutationFn: deleteUserApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] })
      toast.success('User account has been successfully deleted!')
    },
    onError: (error: any) => {
      toast.error(`Failed to delete user: ${error.message}`)
    },
  })

  return { isDeleting, deleteUser, deleteUserAsync }
}
